import OMOPlayLogo from "../../assets/images/omoplay_logo_black.svg";
import CounselForm from "./CounselForm";
import AnotherMallForm from "./AnotherMallForm";
import {Alert, Button, Dropdown, Stepper, TextInput} from "omoplay";
import CheckWhiteBoldIcon from "../../assets/images/icon.check.white.svg";
import CheckBlueBoldIcon from "../../assets/images/icon.check.blue.bold.svg";
import CancelWhiteBoldIcon from "../../assets/images/icon.cancel.white.svg";
import CancelBoldIcon from "../../assets/images/icon.cancel.bold.svg";
import CheckBlueIcon from "../../assets/images/icon.blue.check.svg";
import ValidCheckForm from "./ValidCheckForm";
import GuideButtonFrom from "./GuideButtonFrom";
import {
    postConnectRegistration,
    postRegistrationScreen,
    updateHostingPlatform
} from "../../api/account/account.api";
import React, {useEffect, useState} from "react";
import ImageForm from "../ImageForm";
import ConnectFin from "../../assets/images/connect_setting_fin.svg";
import {useSearchParams} from "react-router-dom";
import {HOSTING_MALL_PLATFORMS, HOSTING_OMOPLAY, hostingLabelOf} from "../../constants/hosting";
import {useRecoilValue} from "recoil";
import {accountSelector} from "../../store/selector/selector";


const OMOConnectSettingsForm = ({isConnect}) => {
    const [submitDisabled, setSubmitDisabled] = useState(true)
    /*
      🔴 **기본값은 `HOSTING_OMOPLAY` 다. `"카페24"` 로 두면 안 된다**(2026-09-01, OB-26).

      이 화면(`/settings/connect`)은 **고객이 직접 들어올 수 있는 라우트**다(`App.js`).
      기본값이 `"카페24"` 였을 때는 고객이 드롭다운을 건드리지 않아도 STEP 0 '계정 제출' 에서
      `POST /account/hosting` 이 `hosting_name='카페24'` 를 찍었다 — 오모플레이 제공 자사몰
      고객에게도 마찬가지였다(온보딩 위저드의 OB-25 와 같은 결함, 진입점만 다르다).

      이제 목록 첫 항목이 '오모플레이 제공 자사몰' 이고 그것이 기본값이다.
      그 경우 몰 운영자 계정은 받지 않는다(받을 것이 없다).
    */
    const [hostingName, setHostingName] = useState(HOSTING_OMOPLAY)
    const [hostingLabel, setHostingLabel] = useState(hostingLabelOf(HOSTING_OMOPLAY))
    const [hostingId, setHostingId] = useState("")
    const [hostingPwd, setHostingPwd] = useState("")
    const [confirmName, setConfirmName] = useState("다음")
    const [useKakaoSync, setUseKakaoSync] = useState()
    const [validNotBusinessSettings, setValidNotBusinessSetting] = useState([false])
    const [isCounsel, setIsCounsel] = useState(false)
    const [checkedLogo, setCheckedLogo] = useState(false)
    const [logoUrl, setLogoUrl] = useState(null)
    const [benefitName, setBenefitName] = useState("")
    const [benefitCondition, setBenefitCondition] = useState("")
    const [benefitPeriod, setBenefitPeriod] = useState("발급일로부터 30일")
    const [step, setStep] = useState(0)
    const [query] = useSearchParams()
    const id = query.get("id");

    if (!id) {
        alert("권한이 없습니다.")
        window.location.href = "/"
    }

    const account = useRecoilValue(accountSelector)

    useEffect(() => {
        const permissions = account?.channels?.find(ch => ch.id === Number(id))?.permissions.filter(pm => pm.serviceType !== "Owner")

        if (account?.channels?.find(ch => ch.id === Number(id))
            ?.permissions.find(pm => pm.grant === "ADMIN" && pm.serviceType === (isConnect ? "Connect" : "Screen"))
        ) {
            window.location.href = "/"
        }
        if (step < 3) {
            const alreadyConnectOrScreenPerm = permissions?.findIndex(pm => (pm.serviceType === "Screen" || pm.serviceType === "Connect")) > -1
            if (alreadyConnectOrScreenPerm) {
                setStep(2)
            }
        }
    }, []);

    useEffect(() => {
        setConfirmName("다음")
        if (step === 0) {
            setConfirmName("계정 제출 및 다음 단계로 가기")
            if (hostingName === HOSTING_OMOPLAY) {
                // 오모플레이가 자사몰을 제공하는 경우 제출할 계정이 없다.
                setSubmitDisabled(false)
                setConfirmName("다음 단계로 가기")
            } else if (useKakaoSync) {
                setSubmitDisabled(hostingId.length === 0)
                setConfirmName("다음 단계로 가기")
            } else if (useKakaoSync === false) {
                setSubmitDisabled(false)
                setConfirmName("다음 단계로 가기")
            } else {
                setSubmitDisabled(hostingId.length === 0 || hostingPwd.length === 0)
            }
        } else if (step === 1) {
            setSubmitDisabled(validNotBusinessSettings.some(item => !item))
        } else if (step === 2) {
            setSubmitDisabled(false)
            if (isConnect) {
                setSubmitDisabled(false)
                setConfirmName("완료")
            }
        } else if (step === 3) {
            setConfirmName("완료")
            setSubmitDisabled(false)
        } else if (step === 4) {
            setSubmitDisabled(false)
        } else if (step === 5) {
            setSubmitDisabled(false)
            setConfirmName("완료")
        } else {
            setSubmitDisabled(true)
        }
        // `hostingName` 추가(2026-09-01) — 플랫폼을 바꾸면 제출 조건이 달라진다.
        // 넣지 않으면 오모플레이↔쇼핑몰 전환 시 버튼 활성 상태가 한 박자 늦게 반영된다.
    }, [step, hostingName, hostingId, hostingPwd, validNotBusinessSettings, useKakaoSync, checkedLogo]);

    const changeStep = (step) => {
        setStep(step)
    }

    return (
        <>

            <div>
                <div className="w-[200px]">
                    <img alt="" src={OMOPlayLogo} />
                </div>
            </div>
            {
                isCounsel ? (
                    <>
                        <div className="text-gray-900 font-bold text-[28px]">
                            오프라인 매장만을 운영하는 경우에도<br/>
                            오모플레이를 사용할 수 있습니다
                        </div>
                        <CounselForm onPrev={() => setIsCounsel(false)} />
                    </>
                ) : (
                    <>
                        {
                            (useKakaoSync === false && step === 1) ? (
                                <>
                                    <div className="text-gray-900 font-bold text-[28px]">
                                        카카오 연동이 되어있지 않은<br/>
                                        독립몰의 경우 별도 상담이 필요합니다
                                    </div>
                                    <AnotherMallForm onPrev={() => {
                                        changeStep(0)
                                        setUseKakaoSync(true)
                                    }} />
                                </>
                            ) : (
                                <>
                                    <Stepper
                                        listLabel={[]}
                                        totalStep={isConnect ? 2 : 3}
                                        stepActive={step + 1}
                                    />
                                    {
                                        step === 0 && (
                                            <>
                                                <div className="text-gray-900 font-bold text-[28px]">
                                                    환영합니다! 오모플레이 세팅을 위해<br/>
                                                    홈페이지 연동 방식을 알려주세요
                                                </div>
                                                <div>
                                                    <div className="flex-col gap-[32px]">
                                                        <div>
                                                            <div>연동 방식 (오모플레이 제공 / 카페24 · 아임웹 등)</div>
                                                            {/*
                                                              목록은 `constants/hosting.js` 에서 가져온다(2026-09-01) —
                                                              온보딩 위저드와 **같은 값**을 써야 하고, 서버 어휘
                                                              (`HostingName.kt`)와도 한 곳에서 맞춰야 한다.
                                                              '오모플레이 제공 자사몰' 을 **첫 항목**으로 둔다(= 기본값).
                                                            */}
                                                            <Dropdown variants="default" initialValue={hostingName} items={[
                                                                {label: hostingLabelOf(HOSTING_OMOPLAY), value: HOSTING_OMOPLAY},
                                                                ...HOSTING_MALL_PLATFORMS
                                                            ]} onChanged={(items) => {
                                                                setUseKakaoSync(undefined)
                                                                setHostingName(items[0].value)
                                                                setHostingLabel(items[0].label ?? items[0].value)
                                                            }} />
                                                        </div>
                                                        {
                                                            hostingName === HOSTING_OMOPLAY ? (
                                                                /*
                                                                  오모플레이 제공 자사몰 = 받을 계정 정보가 없다(2026-09-01).
                                                                  종전에는 이 분기가 없어서 고객이 몰 운영자 아이디·비밀번호를
                                                                  입력해야 진행할 수 있었고, 그래서 아무 값이나 넣고 넘어가거나
                                                                  드롭다운을 건드리지 않은 채 '카페24' 로 접수됐다.
                                                                */
                                                                <Alert title="오모플레이가 홈페이지를 제공해 드립니다." type="warning" withIcon={true}>
                                                                    <label className="text-[13px]">
                                                                        별도의 쇼핑몰 계정 정보가 필요하지 않습니다.<br/>
                                                                        카카오 싱크 연동에 필요한 홈페이지(약관·개인정보처리방침 포함)를 오모플레이가 만들어 드립니다.<br/>
                                                                        이미 운영 중인 쇼핑몰과 연동하시려면 위에서 해당 플랫폼을 선택해 주세요.
                                                                    </label>
                                                                </Alert>
                                                            ) : hostingName === "독립몰" ? (
                                                                <>
                                                                    <div className="flex gap-2">
                                                                        <Button variants={useKakaoSync ? "primary" : "outlined"} value={
                                                                            <div className="flex gap-1">
                                                                                <img src={useKakaoSync ? CheckWhiteBoldIcon : CheckBlueBoldIcon} alt="check_bold" />
                                                                                <div>카카오 싱크/로그인을 사용하고 있습니다</div>
                                                                            </div>
                                                                        } onClick={() => setUseKakaoSync(true)} />
                                                                        <Button variants={useKakaoSync === false ? "danger" : "outlined"} value={
                                                                            <div className="flex gap-1">
                                                                                <img src={useKakaoSync === false ? CancelWhiteBoldIcon : CancelBoldIcon} alt="cancel_bold" />
                                                                                <div>사용하고 있지 않습니다</div>
                                                                            </div>
                                                                        } onClick={() => setUseKakaoSync(false)} />
                                                                    </div>
                                                                    {
                                                                        useKakaoSync && (
                                                                            <div>
                                                                                <div>독립몰 주소 (URL)<span className="text-red-500">*</span></div>
                                                                                <TextInput placeholder="독립몰 주소를 입력해주세요."
                                                                                           autoComplete="off"
                                                                                           id="hostingId"
                                                                                           value={hostingId}
                                                                                           onChange={(e) => {
                                                                                               setHostingId(e.currentTarget.value)
                                                                                           }} />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div>
                                                                        <div>운영자 계정 아이디</div>
                                                                        <TextInput placeholder="아이디를 입력해주세요."
                                                                                   autoComplete="off"
                                                                                   id="hostingId"
                                                                                   value={hostingId}
                                                                                   onChange={(e) => {
                                                                                       setHostingId(e.currentTarget.value)
                                                                                   }} />
                                                                    </div>
                                                                    <div style={{width: "100%"}}>
                                                                        <div>비밀번호</div>
                                                                        <TextInput type="password" placeholder="비밀번호를 입력해주세요."
                                                                                   autoComplete="new-password"
                                                                                   id="hostingPwd"
                                                                                   value={hostingPwd}
                                                                                   onChange={(e) => {
                                                                                       setHostingPwd(e.currentTarget.value)
                                                                                   }} />
                                                                    </div>
                                                                    <Alert title="계정정보가 왜 필요한가요?" type="warning" withIcon={true}>
                                                                        <label className="text-[13px]">
                                                                            카카오 싱크 설정, 회원가입 필수정보 설정, 약관 확인을 위해 필요합니다.<br/>
                                                                            제공해주신 정보는 안전하게 암호화 되어 보관되며, 최소한의 필요 인원 외에는 접근할 수 없도록 관리하고 있습니다.<br/>
                                                                            계정 정보가 부정확한 경우 세팅이 지연될 수 있습니다.
                                                                        </label>
                                                                    </Alert>
                                                                    <div className="text-[20px] font-bold">온라인 쇼핑몰이 없으신가요?</div>
                                                                    <div>오프라인 매장만 운영하는 경우에도(식당, 카페 등) 오모플레이를 이용할 수 있습니다.
                                                                        <span className="ml-1 text-primary pointer underline" onClick={() => {
                                                                            setIsCounsel(true)
                                                                        }}>상담하기</span>
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        step > 0 && step < 3 && (
                                            <div className="rounded-[12px] px-[20px] py-[16px] bg-[rgba(247,247,249,1)]">
                                                <div className="flex-col gap-2">
                                                    <div className="text-primary font-semibold">준비 완료!</div>
                                                    <div className="flex-align-center gap-1 relative">
                                                        <li>
                                                            쇼핑몰 호스팅사 확인
                                                        </li>
                                                        <div className="w-[120px] border-b-2 border-[rgba(231,231,235,1)] border-dashed" />
                                                        <div className="flex gap-1 flex-1">
                                                            <img alt="check" src={CheckBlueIcon} />
                                                            <div>{hostingLabel}</div>
                                                        </div>
                                                    </div>
                                                    {
                                                        step > 1 && step < 3 && (
                                                            <div className="flex-align-center gap-1 relative">
                                                                <li>
                                                                    카카오 디벨로퍼 초대
                                                                </li>
                                                                <div className="w-[120px] border-b-2 border-[rgba(231,231,235,1)] border-dashed" />
                                                                <div className="flex gap-1 flex-1">
                                                                    <img alt="check" src={CheckBlueIcon} />
                                                                    <div>카카오 디벨로퍼에 오모플레이 계정 초대</div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        step === 1 && (
                                            <>
                                                <div className="text-gray-900 font-bold text-[28px]">
                                                    이제 필요한 작업을 알려드리겠습니다
                                                </div>
                                                <div className="flex-col gap-[23px] min-w-[500px]">
                                                    <ValidCheckForm index={1} title="카카오싱크를 이미 사용 중인지 확인하세요"
                                                                    isOpen={validNotBusinessSettings[0]}
                                                                    onChecked={(checked) => setValidNotBusinessSetting((prev) => {
                                                                        prev[0] = checked
                                                                        return [...prev]
                                                                    })}
                                                    >
                                                        <div className="flex-col item gap-8 p-[24px]">
                                                            <div>
                                                                <div className="text-primary mb-4">신규 사용이라면 다음 단계로 넘어가세요.</div>
                                                                <div className="text-red-500 font-semibold">만약 이미 카카오싱크를 사용중이라면<br />반드시 아래 가이드를 통해 카카오 디벨로퍼 계정을 초대 해주세요.</div>
                                                            </div>
                                                            <div>
                                                                <div className="font-medium">아래의 초대 가이드를 먼저 확인해주세요 ↓</div>
                                                                <GuideButtonFrom buttonName="초대 가이드 - 카카오 디벨로퍼에 오모플레이 계정 초대하기"
                                                                                 url="https://omoplay.notion.site/2332d9e7196a81f7842ad793bfa3a471"
                                                                />
                                                            </div>
                                                            <div className="border rounded-[12px] bg-white flex-center-all p-[16px] text-center font-medium">
                                                                팀원으로 초대할 계정<br/>omoplay@kakao.com
                                                            </div>
                                                        </div>
                                                    </ValidCheckForm>
                                                </div>
                                            </>
                                        )
                                    }
                                    {
                                        (step === 2 && !isConnect) && (
                                            <>
                                                <ValidCheckForm index={1} title="브랜드 로고 첨부하기"
                                                                isOpen={true}
                                                                isNotRequired={true}
                                                                onChecked={(checked) => setCheckedLogo(checked)}
                                                >
                                                    <div className="p-[36px]">
                                                        <div className="text-gray-500 text-s">(권장 사이즈: 135 x 135px)</div>
                                                        <ImageForm key={logoUrl} imageUrl={logoUrl} onChangeImageUrl={(url) => setLogoUrl(url)} />
                                                    </div>
                                                </ValidCheckForm>
                                                <ValidCheckForm index={2} title="회원가입 혜택 설정"
                                                                isOpen={true}
                                                                isNotRequired={true}
                                                                onChecked={(checked) => setCheckedLogo(checked)}
                                                >
                                                    <div className="flex-col gap-2 p-[16px]">
                                                        <div className="flex-align-center gap-4">
                                                            <div>혜택명</div>
                                                            <TextInput placeholder="ex) 3,000원 할인 쿠폰"
                                                                       autoComplete="off"
                                                                       id="benefitName"
                                                                       value={benefitName}
                                                                       onChange={(e) => {
                                                                           setBenefitName(e.currentTarget.value)
                                                                       }} />
                                                        </div>
                                                        <div className="flex-align-center gap-4">
                                                            <div>혜택 조건</div>
                                                            <TextInput placeholder="ex) 10,000원 이상 결제 시"
                                                                       autoComplete="off"
                                                                       id="benefitName"
                                                                       value={benefitCondition}
                                                                       onChange={(e) => {
                                                                           setBenefitCondition(e.currentTarget.value)
                                                                       }} />
                                                        </div>
                                                        <div className="flex-align-center gap-4">
                                                            <div>혜택 유효기간</div>
                                                            <TextInput placeholder="ex) 발급일로부터 30일"
                                                                       autoComplete="off"
                                                                       id="benefitName"
                                                                       value={benefitPeriod}
                                                                       onChange={(e) => {
                                                                           setBenefitPeriod(e.currentTarget.value)
                                                                       }} />
                                                        </div>
                                                    </div>
                                                </ValidCheckForm>
                                            </>
                                        )
                                    }
                                    {
                                        (step === 2 && isConnect) && (
                                            <div className="flex-col gap-[32px]">
                                                <div className="text-gray-900 font-bold text-[28px]">
                                                    최고의 고객 회원 파이프라인을<br/>
                                                    구축할 준비가 완료되었습니다
                                                </div>
                                                <div className="text-gray-900 font-semibold text-[20px]">
                                                    <span className="text-primary font-semibold text-[20px]">오모플레이 담당자</span>가 배정되어 서비스 연동작업이 시작됩니다.<br/>
                                                    활성화 까지는 약 1~3 영업일이 소요될 예정이며<br/>
                                                    필요한 경우 연동작업 도중에 담당자가 연락을 드릴 수 있습니다.
                                                </div>
                                                <div>
                                                    <img src={ConnectFin} alt="fin" />
                                                </div>
                                                <div>
                                                    <Alert title="확인해 주세요." type="warning" withIcon={true}>
                                                        <label className="text-[13px]">
                                                            고객 획득 비용은 오모플레이의 서비스를 통해 가입한 경우에만 적용 됩니다.<br/>
                                                            이미 획득한 고객에 대해서는 획득 비용이 중복 청구되지 않습니다.<br/>
                                                            기타 서비스 이용관련 및 이용 요금에 대한 문의는 톡문의를 통해 문의 해주세요.
                                                        </label>
                                                    </Alert>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        (step === 3 && !isConnect) && (
                                            <div className="flex-col gap-[32px]">
                                                <div className="text-gray-900 font-bold text-[28px]">
                                                    깔끔한 디자인 간편 로그인 화면을<br/>
                                                    구축할 준비가 완료되었습니다
                                                </div>
                                                <div className="text-gray-900 font-semibold text-[20px]">
                                                    <span className="text-primary font-semibold text-[20px]">오모플레이 담당자</span>가 배정되어 서비스 연동작업이 시작됩니다.<br/>
                                                    활성화 까지는 약 1~3 영업일이 소요될 예정이며<br/>
                                                    필요한 경우 연동작업 도중에 담당자가 연락을 드릴 수 있습니다.
                                                </div>
                                                <div>
                                                    <img src={ConnectFin} alt="fin" />
                                                </div>
                                                <div className="text-gray-900 font-semibold text-[20px]">
                                                    연동작업이 완료되면 <span className="text-primary font-semibold text-[20px]">오모플레이 플친메시지</span>로 알려드립니다.
                                                    서비스 이용료는 연동작업이 완료된 날을 기준으로 과금이 시작됩니다.
                                                </div>
                                                <div>
                                                    <Alert title="확인해 주세요." type="warning" withIcon={true}>
                                                        <label className="text-[13px]">
                                                            첫달 이용기간은 연동이 완료되는 시점부터 시작됩니다.<br/>
                                                            기타 서비스 이용관련 및 이용 요금에 대한 문의는 톡문의를 통해 문의 해주세요.
                                                        </label>
                                                    </Alert>
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className="flex justify-end gap-2 mt-[12px]">
                                        {
                                            step > 0  && (<Button variants="outlined" value="이전" onClick={() => changeStep(step - 1)} />)
                                        }
                                        <Button variants="primary" disabled={submitDisabled} value={confirmName} onClick={() => {
                                            if (step === 0) {
                                                updateHostingPlatform(id, hostingName, hostingId, hostingPwd)
                                                changeStep(step + 1)
                                            } else if (step === 2 && isConnect) {
                                                /*
                                                  이 폼이 실제로 관리하는 값만 넘긴다(2026-08-20).
                                                  종전에는 id 하나만 넘겨 서버에서 9개 컬럼이 전부 NULL 로
                                                  덮여, 고객이 올린 로고·스티커·객단가·사업자번호·컨셉이 지워졌다.
                                                  서버는 이제 주어진 값만 갱신한다(null = 변경하지 않음).
                                                */
                                                postConnectRegistration(id, hostingName, hostingId, hostingPwd, logoUrl).then(({data}) => {
                                                    if (data !== "success") {
                                                        alert(`신청에 실패했습니다.\n사유: ${data}`)
                                                    } else {
                                                        alert("신청이 완료되었습니다.")
                                                        window.location.href = "/services"
                                                    }
                                                })
                                            } else if (step === 3 && !isConnect) {
                                                postRegistrationScreen(id, logoUrl, `${benefitName},${benefitCondition},${benefitPeriod}`).then(({data}) => {
                                                    if (data !== "success") {
                                                        alert(`신청에 실패했습니다.\n사유: ${data}`)
                                                    } else {
                                                        alert("신청이 완료되었습니다.")
                                                        window.location.href = "/services"
                                                    }
                                                })
                                            } else {
                                                changeStep(step + 1)
                                            }
                                        }} />
                                    </div>
                                </>
                            )
                        }
                    </>
                )
            }
        </>
    )
}

export default OMOConnectSettingsForm